import { useState, FC, useEffect } from "react";
import { GridSelectorModalWindow } from "../../../components/modalWindows/GridSelectorModalWindow";
import GoodsGrid from "./GoodsGrid";
import { v4 as uuidv4 } from 'uuid';
import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";
import GoodsGridPluginSettings from "./GoodsGridPluginSettings";
import { useTranslation } from "react-i18next";
import renderGlobalAlert from "../../../system/hooks/useGlobalAlert";
import GoodsGridPluginSettingsForMovement from "../../Documents/RequestForMovement/RequestForMovementCreator/GoodsGridPluginSettingsForMovement";
import GoodsSubstanceGridPluginSettingsForMovement from "../../Documents/RequestForMovement/RequestForMovementCreator/GoodsSubstanceGridPluginSettingsForMovement";
import { IdTableVariant } from "../../../@types/enumsGlobal";
import { GosContractItemsPluginSettings } from "../GosContract/pluginSettings/gosContractItemsPluginSettings";

const GoodsSelectorModal: FC<IGridSelectorModalProps> = (props) => {
    const [selectRow, setSelectRow] = useState<ISelectGridRow>()
    const [entity, setEntity] = useState<IEntitySimpleDTO>(props.selectedEntity ?? {} as IEntitySimpleDTO)
    const [entities, setEntities] = useState<IEntitySimpleDTO[]>(props.selectedEntities ?? []);
    const [focusTaken, setFocusTaken] = useState<boolean>(false);
    const [disabled, setDisabled] = useState<boolean>(true)
    const gridId = uuidv4();
    let plugin = props.gosContract ? GosContractItemsPluginSettings : GoodsGridPluginSettings 
    
    const { t } = useTranslation();
    
    if (props.idTable === IdTableVariant.RequestForMovement) {
        if (props.gridDisplayName) {
            plugin = props?.gridDisplayName === t("documents.requestForMovement.searchByMnn")
                ? GoodsSubstanceGridPluginSettingsForMovement
                : GoodsGridPluginSettingsForMovement
        }
    }
    
    useEffect(() => {
        if (props.multipleSelect) {
            if(props.isSearchForMultyselect){
                setDisabled(false)
            } else {
                setDisabled(entities.length === 0);
            }
        } else {
            setDisabled(!entity?.idGlobal);
        }
    }, [entity, entities, props.multipleSelect]);

    const isLocked = (isLocked?: boolean) => {
        if (isLocked) {
            renderGlobalAlert({
                variant: "danger",
                title: t('general.goodsIsLocked'),
                statusCode: 500,
            });  
            return false
        }
        return true
    }

    const getPluginName = () => {
        let pluginName = plugin?.name
        if (props.idTable === IdTableVariant.RequestForMovement) {
            if (props.gridDisplayName) {
                pluginName = props?.gridDisplayName
                plugin = pluginName === t("documents.requestForMovement.searchByMnn") ? GoodsSubstanceGridPluginSettingsForMovement : GoodsGridPluginSettingsForMovement
            }
        }
        return pluginName
    } 
    
    return <GridSelectorModalWindow
        entityToPressEnter={entity}
        gridDisplayName={getPluginName() ?? t('directory.goods.title')} 
        fullScreen
        modalKey="goodsSelectorModal"
        focusTaken={focusTaken}
        ok={{
            onClick: () => {
                if (!isLocked(selectRow?.isLocked)) return
                props.multipleSelect ? props.ok(entities) : props.ok?.(entity)
            },
            disabled: disabled
        }}
        cancel={{ onClick: () => props.cancel?.() }}
    >
        {
            plugin
                ? <GoodsGrid
                    showCheckBoxDeleted={props.showCheckBoxDeleted}
                    data={entities}
                    isModal
                    dataFromPluginGridSelectorInput={props.dataFromPluginGridSelectorInput}
                    isSearchForMultyselect={props.isSearchForMultyselect}
                    baseGridFilter={props.gridFilter}
                    gosContract={props.gosContract}
                    gridId={gridId}
                    plugin={plugin}
                    onFocusChanged={(taken: boolean) => {
                        setFocusTaken(taken);
                    }}
                    onSelect={(row, rowDto) => {
                        if (row && rowDto && rowDto.deleted === false) {
                            setSelectRow(row)
                            setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                        } else if (row && rowDto && rowDto.deleted === true) {
                            setDisabled(true)
                        } else if (row) {
                            setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                            setSelectRow(row)
                        } else {
                            setDisabled(true)
                            setEntity({} as IEntitySimpleDTO)
                        }
                    }}
                    onMultipleSelect={(rows) => {
                        rows && setEntities(rows.map(x => ({ idGlobal: x.idGlobal, displayName: x.displayName } as IEntitySimpleDTO)))
                    }}
                    multipleSelect={props.multipleSelect}
                    onDoubleClick={(row, rowDto) => {
                        if (!isLocked(row?.isLocked)) return
                        if (row && rowDto && rowDto.deleted === false) {
                            setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                            props.ok?.({ idGlobal: row.idGlobal, displayName: row.displayName })
                        }
                    }}
                    getUniqueGoodsByStore={props.getUniqueGoodsByStore}
                />
                : <p> {t('general.directoryNotConfigured')}</p>
        }
    </GridSelectorModalWindow>
}

export default GoodsSelectorModal